import React from 'react';
import './ThemeDemo.css';

const ThemeDemo = () => {
    return (
        <div className="theme-demo-container">
            <div className="demo-header">
                <h1>Purple Pink Theme Demo</h1>
                <p>Modern UI Component Showcase</p>
            </div>

            {/* Action Buttons Demo */}
            <section className="demo-section">
                <h2>Circular Action Buttons</h2>
                <div className="demo-buttons">
                    <button className="action-btn-sm edit" title="Edit">
                        <i className="fas fa-edit"></i>
                    </button>
                    <button className="action-btn-sm delete" title="Delete">
                        <i className="fas fa-trash"></i>
                    </button>
                    <button className="action-btn-sm" title="View">
                        <i className="fas fa-eye"></i>
                    </button>
                    <button className="action-btn-sm" title="Download">
                        <i className="fas fa-download"></i>
                    </button>
                </div>
            </section>

            {/* Buttons Demo */}
            <section className="demo-section">
                <h2>Primary Buttons</h2>
                <div className="demo-buttons">
                    <button className="btn btn-primary">
                        <i className="fas fa-plus"></i>
                        Create New
                    </button>
                    <button className="btn btn-primary">
                        <i className="fas fa-save"></i>
                        Save Changes
                    </button>
                    <button className="btn btn-secondary">
                        Cancel
                    </button>
                </div>
            </section>

            {/* Badges Demo */}
            <section className="demo-section">
                <h2>Badges & Chips</h2>
                <div className="demo-badges">
                    <span className="badge badge-info">2 INCH</span>
                    <span className="badge badge-info">Active</span>
                    <span className="badge badge-secondary">Premium</span>
                    <span className="badge badge-success">Completed</span>
                    <span className="badge badge-warning">Pending</span>
                    <span className="badge badge-error">Failed</span>
                </div>
            </section>

            {/* Status Pills Demo */}
            <section className="demo-section">
                <h2>Status Pills</h2>
                <div className="demo-badges">
                    <span className="status-pill active">
                        <span className="dot active"></span>
                        ACTIVE
                    </span>
                    <span className="status-pill inactive">
                        <span className="dot inactive"></span>
                        OFFLINE
                    </span>
                    <span className="status-pill pending">
                        <span className="dot pending"></span>
                        PENDING
                    </span>
                </div>
            </section>

            {/* Table Demo */}
            <section className="demo-section">
                <h2>Modern Table</h2>
                <div className="card glass-card">
                    <div className="table-container p-0">
                        <table className="table-modern">
                            <thead>
                                <tr>
                                    <th>SR</th>
                                    <th>OPERATIONAL DOMAIN</th>
                                    <th>THERMAL DIMENSION</th>
                                    <th>PRODUCTION DIMENSION</th>
                                    <th>STATUS</th>
                                    <th className="text-right">OPERATIONAL ACTION</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>
                                        <div className="font-bold text-primary">Sunrise Hotel & Resort</div>
                                    </td>
                                    <td>
                                        <span className="badge badge-info">2 INCH</span>
                                    </td>
                                    <td>
                                        <span className="badge badge-info">2 INCH</span>
                                    </td>
                                    <td>
                                        <span className="status-pill active">
                                            <span className="dot active"></span>
                                            ACTIVE
                                        </span>
                                    </td>
                                    <td>
                                        <div className="flex justify-end gap-2">
                                            <button className="action-btn-sm edit" title="Edit">
                                                <i className="fas fa-edit"></i>
                                            </button>
                                            <button className="action-btn-sm delete" title="Delete">
                                                <i className="fas fa-trash"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>
                                        <div className="font-bold text-primary">Sunrise Hotel & Resort</div>
                                    </td>
                                    <td>
                                        <span className="badge badge-info">2 INCH</span>
                                    </td>
                                    <td>
                                        <span className="badge badge-info">2 INCH</span>
                                    </td>
                                    <td>
                                        <span className="status-pill inactive">
                                            <span className="dot inactive"></span>
                                            OFFLINE
                                        </span>
                                    </td>
                                    <td>
                                        <div className="flex justify-end gap-2">
                                            <button className="action-btn-sm edit" title="Edit">
                                                <i className="fas fa-edit"></i>
                                            </button>
                                            <button className="action-btn-sm delete" title="Delete">
                                                <i className="fas fa-trash"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

            {/* Cards Demo */}
            <section className="demo-section">
                <h2>Glass Cards</h2>
                <div className="grid grid-cols-3 gap-4">
                    <div className="card glass-card hover-lift animate-fade-in">
                        <h3>Card Title</h3>
                        <p>This is a glass-morphism card with hover effects.</p>
                        <button className="btn btn-primary mt-4">Learn More</button>
                    </div>
                    <div className="card glass-card hover-lift animate-fade-in">
                        <h3>Another Card</h3>
                        <p>Gradient buttons and smooth animations throughout.</p>
                        <button className="btn btn-primary mt-4">Get Started</button>
                    </div>
                    <div className="card glass-card hover-lift animate-fade-in">
                        <h3>Last Card</h3>
                        <p>Purple and pink gradients create a modern look.</p>
                        <button className="btn btn-primary mt-4">Explore</button>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ThemeDemo;
